import { useEffect, useState } from "react";
import { fetchConfiguration } from "../../api/endpoint";
import ApplicationSettings from "./applicationSettings/applicationSettings";
import TermsAndConditions from "./termsAndConditions/termsAndConditions";
import PrivacyPolicy from "./privacyPolicy/privacyPolicy";
import ContactInformation from "./contactInformation/contactInformation";
import PaymentConfig from "./paymentConfig/paymentConfig";
import axios from "axios";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/loader";
import { saveConfigData } from "../../store/slice/configSlice";

const Settings = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Terms and Conditions");
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);
  const { config } = useSelector((state) => state.config);

  useEffect(() => {
    getConfiguration();
  }, []);

  const getConfiguration = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchConfiguration, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      dispatch(saveConfigData(response?.data));
    } catch (error) {
      toast.error("Error fetching payment configuration");
      console.error("Error fetching payment configuration", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="px-md-2 px-1 py-md-2 py-1">
        {/* <h2>Settings</h2> */}
        <ul className="nav nav-tabs">
          {/* <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className={`nav-link ${
              activeTab === "Application Settings" ? "active" : ""
            }`}
            onClick={() => setActiveTab("Application Settings")}
            style={{
              color: activeTab !== "Application Settings" ? "#2c3e50" : "",
            }}
          >
            Application Settings
          </a>
        </li> */}
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${
                activeTab === "Terms and Conditions" ? "active" : ""
              }`}
              onClick={() => setActiveTab("Terms and Conditions")}
              style={{
                color: activeTab !== "Terms and Conditions" ? "#2c3e50" : "",
                fontWeight: activeTab == "Terms and Conditions" ? "600" : "normal",
                fontSize: activeTab == "Terms and Conditions" ? "large" : "medium",
              }}
            >
              Terms and Conditions
            </a>
          </li>
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${
                activeTab === "Privacy Policy" ? "active" : ""
              }`}
              onClick={() => setActiveTab("Privacy Policy")}
              style={{
                color: activeTab !== "Privacy Policy" ? "#2c3e50" : "",
                fontWeight: activeTab == "Privacy Policy" ? "600" : "normal",
                fontSize: activeTab == "Privacy Policy" ? "large" : "medium",
              }}
            >
              Privacy Policy
            </a>
          </li>
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${
                activeTab === "Contact Information" ? "active" : ""
              }`}
              onClick={() => setActiveTab("Contact Information")}
              style={{
                color: activeTab !== "Contact Information" ? "#2c3e50" : "",
                fontWeight: activeTab == "Contact Information" ? "600" : "normal",
                fontSize: activeTab == "Contact Information" ? "large" : "medium",
              }}
            >
              Contact Information
            </a>
          </li>
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${
                activeTab === "Payment Configuration" ? "active" : ""
              }`}
              onClick={() => setActiveTab("Payment Configuration")}
              style={{
                color: activeTab !== "Payment Configuration" ? "#2c3e50" : "",
                fontWeight: activeTab == "Payment Configuration" ? "600" : "normal",
                fontSize: activeTab == "Payment Configuration" ? "large" : "medium",
              }}
            >
              Payment Configuration
            </a>
          </li>
        </ul>
        {activeTab === "Application Settings" && <ApplicationSettings />}
        {activeTab === "Terms and Conditions" && (
          <TermsAndConditions fetchConfig={getConfiguration} />
        )}
        {activeTab === "Privacy Policy" && (
          <PrivacyPolicy fetchConfig={getConfiguration} />
        )}
        {activeTab === "Contact Information" && (
          <ContactInformation fetchConfig={getConfiguration} />
        )}
        {activeTab === "Payment Configuration" && (
          <PaymentConfig fetchConfig={getConfiguration} />
        )}
      </div>
    </>
  );
};

export default Settings;
